/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ServiceAccountsControllerUpdateApiSettingsMutationRequest, ServiceAccountsControllerUpdateApiSettingsMutationResponse, ServiceAccountsControllerUpdateApiSettingsPathParams, ServiceAccountsControllerUpdateApiSettings400, ServiceAccountsControllerUpdateApiSettings401, ServiceAccountsControllerUpdateApiSettings403, ServiceAccountsControllerUpdateApiSettings404 } from "../../models/serviceAccountsController/ServiceAccountsControllerUpdateApiSettings";

function getServiceAccountsControllerUpdateApiSettingsUrl(orgId: ServiceAccountsControllerUpdateApiSettingsPathParams["orgId"]) {
  const res = { method: 'PATCH', url: `/api/v1/organizations/${orgId}/api-settings` as const }  
  return res
}

/**
 * @summary Change the organization API version pin
 * {@link /api/v1/organizations/:orgId/api-settings}
 */
export async function serviceAccountsControllerUpdateApiSettings(orgId: ServiceAccountsControllerUpdateApiSettingsPathParams["orgId"], data: ServiceAccountsControllerUpdateApiSettingsMutationRequest, config: Partial<RequestConfig<ServiceAccountsControllerUpdateApiSettingsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ServiceAccountsControllerUpdateApiSettingsMutationResponse, ResponseErrorConfig<ServiceAccountsControllerUpdateApiSettings400 | ServiceAccountsControllerUpdateApiSettings401 | ServiceAccountsControllerUpdateApiSettings403 | ServiceAccountsControllerUpdateApiSettings404>, ServiceAccountsControllerUpdateApiSettingsMutationRequest>({ method : "PATCH", url : getServiceAccountsControllerUpdateApiSettingsUrl(orgId).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}